import { type RefObject, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import sprites from "/src/shared/assets/sprite.svg";

export const ScrollToTopButton = ({
	containerRef,
}: {
	containerRef?: RefObject<HTMLDivElement | null>;
}) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const el = containerRef?.current;
		if (!el) return;

		const handleScroll = () => {
			setIsVisible(el.scrollTop > 500);
		};

		el.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => el.removeEventListener("scroll", handleScroll);
	}, [containerRef]);

	const scrollToTop = () => {
		containerRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
	};

	if (!isVisible) return null;

	return (
		<Button
			onClick={scrollToTop}
			variant="dropdown"
			className="flex gap-1 items-center sticky top-3 z-50 !p-2 h-fit bg-background shadow-lg self-end mr-3"
		>
			<span className="font-bold">Back to top</span>
			<svg
				aria-label="arrow-up"
				role="img"
				fill="currentColor"
				className="h-3 w-4"
			>
				<use xlinkHref={`${sprites}#scroll-arrow-up`} />
			</svg>
		</Button>
	);
};
